export default __webpack_public_path__ + "static/media/Img030.1d04407a.jpg";